<template>
  <div>
    <el-descriptions title="基本信息" :style="isHandle ? style1 : null">
      <el-descriptions-item :label="info.releaseTenantIsPersonal ? '询价人' : '询价单位'">
        {{ info.inquirePriceParty || '--' }}
      </el-descriptions-item>
      <el-descriptions-item label="业务类型">{{ defaultFormat(info.businessTypeDesc) }}</el-descriptions-item>
      <el-descriptions-item label="渠道要求">{{ defaultFormat(info.channelRequireDesc) }}</el-descriptions-item>
      <el-descriptions-item label="交付方式">{{ defaultFormat(info.deliveryMethodDesc) }}</el-descriptions-item>
      <el-descriptions-item label="期望交期">{{ formatDate(info.expectedDeliveryDate) }}</el-descriptions-item>
      <el-descriptions-item label="备用机">{{ info.requireSpareMachineFlag ? '需要' : info.requireSpareMachineFlag === false
        ? '不需要' : '--' }}</el-descriptions-item>
      <el-descriptions-item label="创建人">{{ defaultFormat(info.createUserName) }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">{{ defaultFormat(info.createUserPhone) }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style2 : null">
      <el-descriptions-item label="交付地址"> {{ $route.name === 'RECOMMEND_BUSINESS_OPPORTUNITIES' ?
        defaultFormat(`${info.deliveryProvinceName || ''}${info.deliveryCityName ||
          ''}`) : defaultFormat(`${info.deliveryProvinceName || ''}${info.deliveryCityName ||
            ''}${info.deliveryAreaName || ''}${info.deliveryDetailAddress || ''}`) }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style2 : null">
      <el-descriptions-item label="询单备注">{{ defaultFormat(info.inquirePriceRemark) }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style3 : null" :contentStyle="{flexWrap: 'wrap'}">
      <el-descriptions-item label="附件">
        <div v-for="img in (info.inquirePriceAnnexList || [])" :key="img.url" class="fileContainer">
          <el-link style="margin-right: 4px;" type="primary" :href="img.url" :underline="false" target="blank"><i class="el-icon-document"
              style="color:#FF5959;margin-right:4px;"></i> {{ img.annexName }}</el-link>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="报修信息" :style="isHandle ? style1 : null">
      <el-descriptions-item label="设备名称">{{ getDesc('deviceName') }}</el-descriptions-item>
      <el-descriptions-item label="设备型号">{{ getDesc('deviceModel') }}</el-descriptions-item>
      <el-descriptions-item label="设备品牌">{{ getDesc('deviceBrandName') }}</el-descriptions-item>
      <el-descriptions-item label="设备序列号">{{ getDesc('deviceSerialNumber') }}</el-descriptions-item>
      <el-descriptions-item label="设备分类">{{ getDesc('standardCategory') }}</el-descriptions-item>
      <el-descriptions-item label="行业分类">{{ getDesc('industryCategory') }}</el-descriptions-item>
      <el-descriptions-item label="数量">{{ getDesc('quantity') }}</el-descriptions-item>
      <el-descriptions-item label="故障类型">{{ getDesc('faultTypeName') }}</el-descriptions-item>
      <el-descriptions-item label="故障编码">{{ getDesc('faultCode') }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style2 : null">
      <el-descriptions-item label="故障描述">{{ getDesc('faultDescription') }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style3 : null">
      <el-descriptions-item label="故障图片">
        <upload size="mini" :disabled="true" :value="faultImageList" />
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions v-if="info.sparePartList && info.sparePartList.length" title="备件清单" :colon="false" :style="isHandle ? style4 : null" class="device-table" :labelStyle="{ margin: 0 }">
      <el-descriptions-item>
        <TableWithPagination
          tableBorder="default"
          :columnList="columnList"
          :tableData="info.sparePartList">
        </TableWithPagination>
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :style="isHandle ? style4 : null">
      <span slot="title">收货信息</span>
      <el-descriptions-item label="收货人">{{ defaultFormat(info.deliveryUserName) }}</el-descriptions-item>
      <el-descriptions-item label="收货电话">{{ defaultFormat(info.deliveryPhone) }}</el-descriptions-item>
      <el-descriptions-item label="邮编">{{ defaultFormat(info.deliveryPostcode) }}</el-descriptions-item>
      <el-descriptions-item label="收货地址">{{ defaultFormat(`${info.deliveryProvinceName ||
        ''}${info.deliveryCityName ||
        ''}${info.deliveryAreaName || ''}${info.deliveryDetailAddress || ''}`) }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import * as Moment from 'dayjs';
import Upload from '@/components/common/upload';

export default {
  components: {
    Upload,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isHandle: {
      type: Boolean,
      default: false,
    },
    isEncryptable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    faultImageList () {
      return this.info?.deviceList?.[0]?.faultImageList || [];
    },
  },
  data () {
    return {
      columnList: [
        {
          tooltip: true,
          label: '备件编码',
          minWidth: '100px',
          width: '',
          prop: 'code',
        },
        {
          tooltip: true,
          label: '备件图片',
          prop: 'imageList',
          minWidth: '100px',
          render: (h, {row}) => {
            if (row.imageList && !!row.imageList.length) {
              let previewLists = row.imageList.map(item => item.url) || [];
              return row.imageList.map((img, index) => <el-image preview-src-list={previewLists} referrer-policy='unsafe-url' z-Index={index} style={'width:40px;height:40px;vertical-align: middle;margin-right:10px'} src={img.url} ></el-image>);
            } else {
              return '--';
            }
          },
        },
        {
          tooltip: true,
          label: '备件名称',
          minWidth: '120px',
          width: '',
          prop: 'name',
        },
        {
          tooltip: true,
          label: '备件型号',
          minWidth: '100px',
          width: '',
          prop: 'model',
        },
        {
          title: '数量（单位）',
          dataIndex: 'quantity',
          key: 'quantity',
          ellipsis: true,
          render: (h, {row}) => {
            return `${row.quantity}${row.unitName}` || '--';
          },
        },
      ],
      style1: {
        'margin-top': '8px',
        'padding': '18px 18px 0',
        'border-bottom-left-radius': 0,
        'border-bottom-right-radius': 0,
      },
      style2: {
        'padding': '0 18px 0',
        'border-radius': 0,
      },
      style3: {
        padding: '0 18px 0',
        'border-top-left-radius': 0,
        'border-top-right-radius': 0,
      },
      style4: {
        'margin-top': '8px',
        'padding': '18px 18px 0',
        'border-radius': '6px',
      },
    };
  },
  methods: {
    formatDate (text) {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    defaultFormat (v) {
      return v || v === 0 ? v : '--';
    },
    getDesc (key) {
      let ret = '';

      if (key === 'quantity') {
        ret = `${this.info?.deviceList?.[0].quantity}${this.info?.deviceList?.[0].unitName}` || '--';
      } else {
        ret = this.info?.deviceList?.[0][key] || '--';
      }
      return ret;
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.el-descriptions {
  background-color: #fff;
  border-radius: 6px;

  .el-descriptions__header {
    margin-bottom: 10px;

    .el-descriptions__title {
      font-size: 14px;
    }
  }

  &.device-table {
    .el-descriptions__header {
      margin-bottom: 0px;
    }

    .el-descriptions-item__content {
      overflow: auto;
    }
  }
}
</style>
